import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ChooseStudyplanTypePage } from './choose-studyplan-type.page';
import { BotModule } from '@app/bot/bot.module';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    BotModule,
    SharedModule
  ],
  declarations: [ChooseStudyplanTypePage]
})
export class ChooseStudyplanTypePageModule {}
